<template>
  <div class="cup">
    <div class="chart" ref="chartdiv"></div>

    <div class="cup__text">
      <a
        href="#right-sallary"
        class="cup__link cup__heading"
        v-if="chartData.content.linkable"
      >
        {{ chartData.content.text }}
      </a>
      <p class="cup__heading" v-else> {{ chartData.content.text }} </p>

      <p v-if="chartData.content.values.length > 1">
        {{ chartData.content.values[0] }} till {{ chartData.content.values[1] }}  kr/mån
      </p>

      <span v-else>
        <p :class="wrongSalary && chartData.content.base ? 'cup__sallary--wrong' : ''">
          {{ chartData.content.values[0] }} kr/mån
        </p>
      </span>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { mapActions, mapGetters } from 'vuex';

am4core.useTheme(am4themes_animated);

export default {
  name: 'Cup',
  props: [ 'chartData', 'wrongSalary' ],
  mounted() {
    let chart = am4core.create(this.$refs.chartdiv, am4charts.SlicedChart);

    chart.data = [{
      'value': this.chartData.lowValue,
      'color': am4core.color('#F0F0F0')
    }, {
      'value': this.chartData.highValue,
      'color': am4core.color('#6794DC')
    }];

    var cup = 'M421.976,136.204h-23.409l-0.012,0.008c-0.19-20.728-1.405-41.457-3.643-61.704l-1.476-13.352H5.159L3.682,74.507 C1.239,96.601,0,119.273,0,141.895c0,65.221,7.788,126.69,22.52,177.761c7.67,26.588,17.259,50.661,28.5,71.548  c11.793,21.915,25.534,40.556,40.839,55.406l4.364,4.234h206.148l4.364-4.234c15.306-14.85,29.046-33.491,40.839-55.406  c11.241-20.888,20.829-44.96,28.5-71.548c0.325-1.127,0.643-2.266,0.961-3.404h44.94c49.639,0,90.024-40.385,90.024-90.024  C512,176.588,471.615,136.204,421.976,136.204z M421.976,256.252h-32c3.061-19.239,5.329-39.333,6.766-60.048h25.234  c16.582,0,30.024,13.442,30.024,30.024C452,242.81,438.558,256.252,421.976,256.252z'

    var series = chart.series.push(new am4charts.PictorialStackedSeries());

    series.dataFields.value = 'value';
    series.slices.template.propertyFields.fill = 'color';
    series.slices.template.propertyFields.stroke = 'color';
    series.calculatePercent = true;
    series.tooltip.disabled = true;
    series.labels.template.text = '{value.percent.formatNumber("#.0")}%';
    series.alignLabels = true;

    series.maskSprite.path = cup;
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}

</script>


<style lang="scss" scoped>
.cup {
  display: flex;
  flex-direction: column;
  text-align: center;

  &__text {
    width: 100%;
    text-align: center;
  }

  &__link {
    font-family: "Roboto", sans-serif;
    color: $green;
  }

  &__heading {
    margin-bottom: 1rem;
    font-weight: bold;
    display: inline-block;
  }

  &__sallary {
    &--wrong {
      color: red;
    }
  }
}

.chart {
  width: 100%;
  height: 300px;
  font-family: "Roboto", sans-serif;
}
</style>